<template>
  <VView class="winners" back-button-to="/menu" header="Laureaci">
    <VText center>
      Małgorzata 	Listek<br />
      Natalia	Karniej<br />
      Joanna 	Opalińska<br />
      Ewa	Jaroszuk<br />
      Aleksandra	Krupa<br />
      Waldemar 	Sterling<br />
      Paula	Ryłko<br />
      Ania	Gulko<br />
      Karol	Piotrowicz<br />
      Ewelina	Kula<br />
      Weronika 	Pawlik<br />
      Adrian	Madziar<br />
      Mariusz 	Marszał<br />
      Igor	Bigos<br />
      Małgorzata	Zygarowska<br />
      Tomasz	Jurczak
    </VText>
  </VView>
</template>

<script>
import VView from '@/components/VView.vue';
import VText from '@/components/VText.vue';
import VMedia from '@/components/VMedia.vue';
import VButton from '@/components/VButton.vue';
import VButtonGroup from '@/components/VButtonGroup.vue';

export default {
  name: 'Winners',
  components: {
    VView,
    VText,
    VMedia,
    VButton,
    VButtonGroup,
  },
};
</script>

<style lang="scss" scoped>
.winners {
  ::v-deep .button-group {
    margin-top: 100px !important;
  }

  ::v-deep .text {
    font-weight: bold;
  }
}
</style>
